import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './News.css'; // Import CSS file
import Footer from './Footer';

const News = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axios.get('https://arabic-news-api.p.rapidapi.com/cnnarabic', {
          headers: {
            'x-rapidapi-key': '21de8334e4msh1a4aea180805afbp1a7f42jsn6060c3c961db', // Replace with actual API key
            'x-rapidapi-host': 'arabic-news-api.p.rapidapi.com',
          },
        });

        console.log('API Response:', response.data);

        if (response.data && response.data.results) {
          setNews(response.data.results);
        } else {
          setError('Invalid API response format');
        }
      } catch (error) {
        setError('Failed to fetch news');
        console.error('API Error:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  if (loading) return <p className="loading">Loading...</p>;
  if (error) return <p className="error">{error}</p>;

  return (
    <>
    <div className="news-container">
      <h1 className="title">أحدث الأخبار</h1>
      <div className="news-grid">
        {news.length > 0 ? (
          news.map((article, index) => (
            <div key={index} className="news-card">
              {article.image && <img src={article.image} alt={article.headline} className="news-image" />}
              <div className="news-content">
                <h2 className="news-title">{article.headline || 'No Title'}</h2>
                <p className="news-description">{article.underHeadline || 'No Description'}</p>
                <p className="news-date"><strong>Date:</strong> {article.date || 'Unknown'}</p>
                <a href={article.url} target="_blank" rel="noopener noreferrer" className="news-link">
                  Read more
                </a>
              </div>
            </div>
          ))
        ) : (
          <p className="no-news">No news available.</p>
        )}
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default News;
